import { GET, GETWithParams } from "./http.service";

export const getAllCategory = async () => {
  const response = await GET(`Category/list-nested`, false);
  return response;
};

export const getSubCategory = async (requestParams) => {
  const response = await GETWithParams(`Category`, requestParams, false);
  return response;
};
